import { render, staticRenderFns } from "./BSIframe.vue?vue&type=template&id=56a9a65e&scoped=true&"
import script from "./BSIframe.vue?vue&type=script&lang=js&"
export * from "./BSIframe.vue?vue&type=script&lang=js&"
import style0 from "./BSIframe.vue?vue&type=style&index=0&id=56a9a65e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a9a65e",
  null
  
)

export default component.exports